import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import PageHeader from '@/components/PageHeader';
import StaffProfileCard from '@/components/StaffProfileCard';
import AppContext from '@/contexts/appContext';
import useAPI from '@/hooks/useAPI';
import StaffProfileRepository from '@/repositories/StaffProfileRepository';
import Alert from '@/ui/components/Alert';
import Container from '@/ui/components/Container';
import Spinner from '@/ui/components/Spinner';

const MyProfile = () => {
  const navigate = useNavigate();
  const { currentUser } = useContext(AppContext);
  const staffProfileRepository = StaffProfileRepository();

  const { data, isPending, isError } = useAPI({
    queryKey: ['myStaffProfile', currentUser?.email],
    queryFn: () => staffProfileRepository.getMyProfile(),
    enabled: !!currentUser,
    supressErrorMessages: true
  });

  const profile = data?.data;

  return (
    <Container type="page">
      <div className="flex flex-row items-center mb-4">
        <button className="w-6 inline-block text-center mb-1" onClick={() => navigate(-1)}>
          <FontAwesomeIcon data-testid="back-icon" className="text-gray-900" icon={faChevronLeft} />
        </button>
        <div>
          <PageHeader headingText="My Profile" value={1} />
        </div>
      </div>

      {isPending && (
        <div className="text-center w-full">
          <Spinner />
        </div>
      )}

      {isError && <Alert level="error">Unable to load your staff profile.</Alert>}

      {!isPending && !isError && !profile && (
        <Alert level="info">No staff profile found for your account.</Alert>
      )}

      {profile && <StaffProfileCard profile={profile} />}
    </Container>
  );
};

export default MyProfile;
